import { ColumnDef } from '@tanstack/react-table';
import { t } from 'i18next';
import { Hash, UserRoundCheck } from 'lucide-react';
import {
  DataTableFilter,
  RowDataWithActions,
} from '@/components/ui/data-table';
import { DataTableColumnHeader } from '@/components/ui/data-table/data-table-column-header';
import { AdminUser } from '@activepieces/shared';

import { ActiveStatusBadge, CellWithCopyTooltip } from './admin-table-cells';

export const useAdminUsersTable = () => {
  const columns: ColumnDef<RowDataWithActions<AdminUser>>[] = [
    {
      accessorKey: 'lastName',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('Last name')} />
      ),
      cell: ({ row }) => (
        <CellWithCopyTooltip
          displayValue={row.original.lastName}
          tooltipValue={row.original.id}
        />
      ),
    },
    {
      accessorKey: 'firstName',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('First name')} />
      ),
    },
    {
      accessorKey: 'email',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('Email')} />
      ),
    },
    {
      accessorKey: 'externalId',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('User ID')} />
      ),
      cell: ({ row }) => row.original.externalId ?? 'N/A',
    },
    {
      accessorKey: 'externalCustomerId',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('Client ID')} />
      ),
      cell: ({ row }) => row.original.externalCustomerId ?? 'N/A',
    },
    {
      accessorKey: 'status',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('Status')} />
      ),
      cell: ({ row }) => (
        <ActiveStatusBadge isActive={row.original.status === 'ACTIVE'} />
      ),
    },
    {
      accessorKey: 'isInternalKizeo',
    },
  ];

  const filters: DataTableFilter<keyof AdminUser>[] = [
    {
      type: 'input',
      title: t('Search'),
      accessorKey: 'email',
      options: [],
    },
    {
      type: 'input',
      title: t('User ID'),
      accessorKey: 'externalId',
      icon: Hash,
      options: [],
    },
    {
      type: 'input',
      title: t('Client ID'),
      accessorKey: 'externalCustomerId',
      icon: Hash,
      options: [],
    },
    {
      type: 'select',
      title: t('Status'),
      accessorKey: 'status',
      icon: UserRoundCheck,
      options: [
        { label: t('Active'), value: 'ACTIVE' },
        { label: t('Inactive'), value: 'INACTIVE' },
      ],
    },
    {
      type: 'select',
      title: t('Internal Kizeo'),
      accessorKey: 'isInternalKizeo',
      options: [
        { label: t('Yes'), value: 'true' },
        { label: t('No'), value: 'false' },
      ],
    },
  ];

  return { columns, filters };
};
